import { render, staticRenderFns } from "./CreateNote.vue?vue&type=template&id=c68c3e10&scoped=true"
import script from "./CreateNote.vue?vue&type=script&lang=js"
export * from "./CreateNote.vue?vue&type=script&lang=js"
import style0 from "./CreateNote.vue?vue&type=style&index=0&id=c68c3e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68c3e10",
  null
  
)

export default component.exports